import { createContext, ReactNode, useState } from 'react';
import dynamic from 'next/dynamic';

const SitePreferencesModal = dynamic(
  () => import('layout/footer/components/SitePreferencesModal'),
  { ssr: false },
);

interface ISitePreferencesModalProvider {
  children: ReactNode;
}

export const SitePreferencesModalContext = createContext(null);

export const SitePreferencesModalProvider = ({ children }: ISitePreferencesModalProvider) => {
  const [isSitePreferencesModalOpen, setIsSitePreferencesModalOpen] = useState<boolean>(false);
  const closeSitePreferencesModal = () => setIsSitePreferencesModalOpen(false);
  const openSitePreferencesModal = () => setIsSitePreferencesModalOpen(true);

  const values = {
    isSitePreferencesModalOpen,
    closeSitePreferencesModal,
    openSitePreferencesModal,
  };

  return (
    <SitePreferencesModalContext.Provider value={values}>
      {children}
      {isSitePreferencesModalOpen && (
        <SitePreferencesModal
          isModalOpen={isSitePreferencesModalOpen}
          setIsModalOpen={setIsSitePreferencesModalOpen}
        />
      )}
    </SitePreferencesModalContext.Provider>
  );
};
